import { setupWorker } from 'msw'
import { handlersBrowser } from './handlers'

export const worker = setupWorker(...handlersBrowser)
